import { render, staticRenderFns } from "./NewsFilter.vue?vue&type=template&id=baf7a9f4&"
import script from "./NewsFilter.vue?vue&type=script&lang=js&"
export * from "./NewsFilter.vue?vue&type=script&lang=js&"
import style0 from "./NewsFilter.vue?vue&type=style&index=0&id=baf7a9f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports